import React, { useState } from "react";

function AppointmentTypeForm({ setFieldValue, approvalType, designation }) {
  const appointmentOptions =
    designation === "Director" || designation === "Director Shareholder"
      ? [
          { id: "boardApproval", label: "Board Approval" },
          { id: "shareholderApproval", label: "Shareholder Approval" },
          { id: "gazetteNotice", label: "Gazette Notice" },
        ]
      : designation === "Administrator"
      ? [
          { id: "shareholderApproval", label: "Shareholder Approval" },
          { id: "creditorsResolution", label: "Creditors Resolution" },
          { id: "courtOrder", label: "Court Order" },
        ]
      : designation === "Auditor"
      ? [
          { id: "boardApproval", label: "Board Approval" },
          { id: "shareholderApproval", label: "Shareholder Approval" },
        ]
      : [];
  const handleSelectionChange = (value) => {
    setFieldValue("approvalType", value);
  };
  return (
    <form className="mt-4">
      <div className="px-4 py-6 mt-2 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md">
        <h2 className="font-semibold text-gray-700">Select Approval Type</h2>
        <div className="grid grid-cols-3 px-4 py-6 mt-2 bg-white rounded-sm shadow-sm sm:rounded md:rounded-md">
          {appointmentOptions.map((option) => (
            <div key={option.id} className={`flex items-center space-x-2 `}>
              <input
                id={option.id}
                type="radio"
                value={option.id}
                checked={approvalType === option.id}
                onChange={() => handleSelectionChange(option.id)}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
              />
              <label htmlFor={option.id} className="radio-label flex">
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </form>
  );
}

export default AppointmentTypeForm;
